import { render, staticRenderFns } from "./ZoneCreate.vue?vue&type=template&id=67b29ab4&scoped=true"
import script from "./ZoneCreate.vue?vue&type=script&lang=js"
export * from "./ZoneCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b29ab4",
  null
  
)

export default component.exports